import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

import { InternalRequest, useServiceAccessApi } from './use-service-access-api';

export interface ServiceAccessContextValue {
  internalRequests: InternalRequest[];
  refreshInternalRequests: () => void;
}

export const ServiceAccessContext = createContext<ServiceAccessContextValue>({
  internalRequests: [],
  refreshInternalRequests: () => {},
});

export const ServiceAccessContextProvider = (props: PropsWithChildren) => {
  const { getInternalRequestList } = useServiceAccessApi();

  const [internalRequests, setInternalRequests] = useState<InternalRequest[]>(
    []
  );

  const refreshInternalRequests = useCallback(() => {
    getInternalRequestList().then((requests) => {
      setInternalRequests(requests);
    });
  }, [getInternalRequestList]);

  useEffect(() => {
    refreshInternalRequests();
  }, [refreshInternalRequests]);

  return (
    <ServiceAccessContext.Provider
      value={{ internalRequests, refreshInternalRequests }}
    >
      {props.children}
    </ServiceAccessContext.Provider>
  );
};

export const useServiceAccessContext = () => {
  const context = useContext(ServiceAccessContext);
  return context;
};
